import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { Spinner } from "react-bootstrap";

import { Block } from "@material-ui/icons";

const PaymentDeferralOnBreakErrorModal = ({
  open,
  errorMsg,
  closeErrorModal,
  applyLeave,
  paymentGateway,
  paymentMode,
  nextPaymentDate,
  responseLeaveStart,
  responseLeaveEnd,
  classesAffected,
}) => {
  const [loader, setLoader] = useState(false);

  const leaveWithoutDeferral = async () => {
    setLoader(true);
    await applyLeave();
    setLoader(false);
  };

  return (
    <>
      <Dialog open={open} maxWidth="md">
        <DialogContent style={{ textAlign: "center" }}>
          <Block style={{ fontSize: "xxx-large", color: "#FF0000" }} />
          <div className="ml-3 mr-3">
            <h3 style={{ textAlign: "center" }}>Error</h3>
            <p>{errorMsg}</p>
          </div>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{
              backgroundColor: "#FFF",
              borderBlockColor: "#FF712D",
              color: "#FF712D",
            }}
            variant="contained"
            disabled={loader}
            onClick={() => {
              closeErrorModal();
            }}
          >
            Go back
          </Button>
          <Button
            style={{ backgroundColor: "#FF712D", color: "#FFF" }}
            variant="contained"
            disabled={loader || classesAffected === null}
            onClick={leaveWithoutDeferral}
          >
            {loader ? (
              <Spinner animation="border" variant="light" />
            ) : (
              "Proceed without deferral"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PaymentDeferralOnBreakErrorModal;
